import React from "react";
import PropTypes from "prop-types";
import validate from "validate.js";
import jQuery from "jquery";

global.jQuery = jQuery;
global.jquery = jQuery;
global.$ = jQuery;
/**
 * Componente que corresponde a un input básico.
 *
 * @param {*} props
 * @param {string} name nombre del input
 * @param {string} [styleName] class adicional del input. Default undefined.
 * @param {string} [type] tipo de input. Default `text`.
 * @param {function}[handleChange] handler del evento change. Default `undefined`.
 * @param {string|number|boolean} [value] valor por defecto del input. Default null.
 */
export default class Input extends React.Component {
  /**
   * @constructor
   *
   * @param {*} props
   * @param {string} name nombre del input
   * @param {string} [styleName] class adicional del input. Default undefined.
   * @param {string} [placeholder] placeholder del input. Default undefined.
   * @param {string} [type] tipo de input. Default `text`.
   * @param {function}[handleChange] handler del evento change. Default `undefined`.
   * @param {string|number|boolean} [value] valor por defecto del input. Default null.
   */
  constructor(props) {
    super(props);

    this.state = { value: this.props.value };
    this.handleChange = this.handleChange.bind(this);
    this.renderFeedback = this.renderFeedback.bind(this);
    this.getClassName = this.getClassName.bind(this);
    this.renderInput = this.renderInput.bind(this);
    this.bindValidate = this.bindValidate.bind(this);

    let rnd = Math.round(Math.random() * 10000);
    this._id = "form-input-" + rnd + "-" + new Date().getTime(); //    El _id debe generarse en el constructor ya que se ejecuta antes que el render
  }

  /**
   * Cuando el componente se monta se setea el valor.
   */
  componentDidMount() {
    this.bindValidate();
  }

  /**
   * Se encarga de hacer bind del evento validate para los inputs,
   * se utiliza para disparar la validación desde el componente form.
   */
  bindValidate() {
    const thiz = this;
    jQuery(`#${this._id}`).off("validate");
    jQuery(`#${this._id}`).on("validate", event => {
      this.onBlurChange(thiz.state.value);
    });
  }
  /**
   * Se encarga de validar el input
   * @param {*} value
   */
  validate(value) {
    let feedback = null;
    if (this.props.validations) {
      let d = { val: value };
      let constraints = { val: this.props.validations };
      let result = validate(d, constraints);
      feedback = result ? result.val[0].replace("Val ", "") : undefined;
    }
    return feedback;
  }
  /**
   * Handler del evento change del input.
   * @param {*} event
   */
  handleChange(event) {
    const target = event.target;
    let value = target.value;
    value = target.type === "number" && value ? parseFloat(value) : value;
    let feedback = null;
    feedback = this.validate(value);

    // si existe la función handler de, se dispara la invocación.
    if (typeof this.props.onChange !== "undefined") {
      this.props.onChange(value);
    }
    //se seta el valor del input.
    this.setState({
      value: value,
      feedback: feedback
    });
  }
  /**
   * Handler del evento blur change.
   * @param {*} value
   */
  onBlurChange(value) {
    let feedback = this.validate(value);
    this.setState({
      feedback: feedback
    });
  }

  /**
   * Se encarga de renderizar el feedback de validación.
   */
  renderFeedback() {
    const hasFeedback =
      this.state.feedback && this.state.feedback.length > 0 ? true : false;
    return (
      <React.Fragment>
        {hasFeedback && <p className="help is-danger">{this.state.feedback}</p>}
        {!hasFeedback && <p className="help">{this.props.help}</p>}
      </React.Fragment>
    );
  }
  /**
   * Si el input es obligatorio retorna true, en caso contrario retorna false.
   */
  isRequired() {
    return this.props.validations && this.props.validations.presence;
  }
  /**
   * Se encarga de recurmerar el classname teniendo en cuenta si el input
   * requiere o no validación.
   */
  getClassName() {
    let clazz =
      this.props.type == "textarea" ? "textarea" : this.props.styleName;
    if (this.isRequired() && this.state.feedback) {
      clazz += " is-danger";
    } else if (this.isRequired) {
      clazz += " is-success";
    }
    return clazz;
  }
  /**
   * Se encarga de renderizar el input
   */
  renderInput() {
    if (this.props.type == "textarea") {
      return (
        <textarea
          id={this._id}
          name={this.props.name}
          rows={this.props.rows}
          placeholder={this.props.placeholder}
          className={this.getClassName()}
          value={this.state.value}
          required={this.isRequired()}
          onChange={this.handleChange}
          data-id={this.props.idx}
          disabled={this.props.disabled}
        />
      );
    }
    return (
      <input
        id={this._id}
        type={this.props.type}
        name={this.props.name}
        placeholder={this.props.placeholder}
        className={this.getClassName()}
        value={this.state.value}
        required={this.isRequired()}
        onChange={this.handleChange}
        data-id={this.props.idx}
        disabled={this.props.disabled}
      />
    );
  }

  /**
   * Se encarga de renderizar el componente.
   */
  render() {
    let clazz = this.props.validations ? "was-validated" : "";
    return (
      <div className="field">
        <label className="label">{this.props.label}</label>
        <div className="control has-icons-right">
          {this.renderInput()}
          {this.isRequired() && (
            <span className="icon is-small is-right">
              <i className="fas fa-asterisk" />
            </span>
          )}
        </div>
        {this.renderFeedback()}
      </div>
    );
  }
}

/**
 * @param {*} props
 * @param {string} name nombre del input
 * @param {string} [styleName] class adicional del input. Default undefined.
 * @param {string} [placeholder] placeholder del input. Default undefined.
 * @param {string} [type] tipo de input. Default `text`.
 * @param {function}[handleChange] handler del evento change. Default `undefined`.
 * @param {string|number|boolean} [value] valor por defecto del input. Default null.
 */
Input.propTypes = {
  name: PropTypes.string,
  styleName: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  label: PropTypes.string,
  help: PropTypes.string,
  validations: PropTypes.object
};

Input.defaultProps = {
  styleName: "input",
  value: "",
  label: "",
  help: "",
  rows: 3
};
